var React = require('react');

function XSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_2282","data-name":"Path 2282","d":"M0,0H24V24H0Z","transform":"translate(0)","fill":"none","key":0}),React.createElement("path",{"id":"Union_6","data-name":"Union 6","d":"M10.384,11.444,1.061,20.766,0,19.706l9.323-9.322L0,1.061,1.061,0l9.323,9.322L19.706,0l1.061,1.061-9.323,9.322,9.323,9.322-1.061,1.06Z","transform":"translate(1.617 1.617)","fill":"#111","key":1})]);
}

XSmall.defaultProps = {"id":"icon_X_smoll","data-name":"icon / X smoll","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = XSmall;

XSmall.default = XSmall;
